// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CrVML","option":"styles_option__2txs9","active":"styles_active__2EmKx"};